import { ApolloError } from '@apollo/client';
import { COMMON_LIBRARY_CONSTANTS, getApolloErrorMessages } from '@netfront/common-library';

const TOKEN_EXPIRED_PATTERNS = ['IDX0223', 'Lifetime validation failed', 'token is expired'];

const isTokenExpiredError = (error: ApolloError | Error): boolean => {
  const check = (msg: string) => TOKEN_EXPIRED_PATTERNS.some((p) => msg.includes(p));

  const { graphQLErrors = [], networkError } = error as ApolloError;

  const networkErrors = ((networkError as unknown as { result?: { errors?: { message: string }[] } })?.result?.errors) ?? [];
  const hasNetworkTokenExpired = networkErrors.some((e) => check(e.message));
  const hasGraphQLTokenExpired = graphQLErrors.some((e) => check(e.message));

  return hasNetworkTokenExpired || hasGraphQLTokenExpired;
};

const getToastErrorMessages = ({
  error,
  shouldUseFriendlyErrorMessage = false,
}: {
  error: ApolloError | Error;
  shouldUseFriendlyErrorMessage: boolean;
}): string[] => {
  const {
    MESSAGES: {
      ERROR: { UNEXPECTED: defaultErrorMessage },
    },
  } = COMMON_LIBRARY_CONSTANTS;

  let errorMessages: string[] = [defaultErrorMessage];

  if (!shouldUseFriendlyErrorMessage) {
    return errorMessages;
  }

  const { networkError } = error as unknown as { networkError };

  if (networkError) {
    const {
      result: { errors },
    } = networkError;
    errorMessages = [errors[0].message];
  } else if (error instanceof ApolloError) {
    errorMessages = getApolloErrorMessages(error);
  } else if (error instanceof Error) {
    errorMessages = [error.message];
  }

  return errorMessages;
};

export { getToastErrorMessages, isTokenExpiredError };
